import "./Products.css";
import data from "./productList.json";
import brands from "./brandList.json";

import Container from "react-bootstrap/esm/Container";
import PrevArrow from "../UI/CustomButton/Arrows/PrevArrow";
import RightArrow from "../UI/CustomButton/Arrows/RightArrow";
import producList from "./productList.json";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState, useEffect, useRef } from "react";
import Accordion from "react-bootstrap/Accordion";

const Products = () => {
  const [windowSize, setWindowSize] = useState(undefined);
  const [slideCount, setSlideCount] = useState(1);
  const [brandData, setBrandData] = useState(brands[0]);
  const collapseHandler = () => {
    const product_wrapper = document.querySelector(".product_card_wrapper");
    const element =
      product_wrapper.getElementsByClassName("accordion-collapse");
    const collapse_button =
      product_wrapper.querySelectorAll(".accordion-button");
    for (var i = 0; i < element.length; i++) {
      element[i].classList.remove("show");
    }
    for (var i = 0; i < collapse_button.length; i++) {
      collapse_button[i].setAttribute("aria-expanded", "false");
      collapse_button[i].classList.add("collapsed");
    }
  };

  useEffect(() => {
    // var targetDivNext = document.querySelectorAll(".slick-next");
    // var targetDivPrev = document.querySelectorAll(".slick-prev");
    // targetDivNext[1].addEventListener("click", collapseHandler);
    // targetDivPrev[1].addEventListener("click", collapseHandler);
    function handleResize() {
      setWindowSize(window.innerWidth);
      if (window.innerWidth >= 1024) {
        setSlideCount(2);
      } else {
        setSlideCount(1);
      }
    }
    handleResize();

    window.addEventListener("resize", handleResize);
  }, []);
  const brandHandler = (product_id) => {
    const sorted_brands = brands.find((item) => item.id === product_id);
    setBrandData(sorted_brands);
  };
  const scrollView = () => {
    var brands = document.getElementById("brands");
    brands.scrollIntoView();
  };

  const settings_products = {
    dots: windowSize >= 1024 ? true : false,
    infinite: true,
    speed: 500,
    slidesToShow: slideCount,
    slidesToScroll: slideCount,
    prevArrow: <PrevArrow color={"#fe5a0e"} />,
    nextArrow: <RightArrow color={"#fe5a0e"} />,
  };
  const settings = {
    dots: windowSize >= 1024 ? true : false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow color={"#fe5a0e"} />,
    nextArrow: <RightArrow color={"#fe5a0e"} />,
  };

  return (
    <>
      <div className="product_root" id="products">
        <div className="product_wrapper">
          <h2>
            Our Products
            <hr className="product_line"></hr>
          </h2>
          <div className="product_descrip">
            <p>
              Discover our diverse range of high-quality products for LCV/PV/HCV
              vehicles, all backed by a 100% genuine guarantee. We provide both
              pan-India and export services for all our products, ensuring
              efficient and reliable delivery. Shop with us to find the best
              products to enhance your vehicle's performance and appearance.
            </p>
          </div>
          <div className="product_card_wrapper">
            <Slider {...settings_products}>
              {data.map((item, key) => (
                <div key={key}>
                  <div className="custom_card">
                    <div className="card_image">
                      <img src="/assets/images/2.jpg"></img>
                      <hr className="image_line"></hr>
                    </div>
                    <Accordion defaultActiveKey={[key]} alwaysOpen>
                      <Accordion.Item eventKey={key}>
                        <Accordion.Header>
                          <p
                            className="product_name"
                            dangerouslySetInnerHTML={{
                              __html: item.product_name,
                            }}
                          ></p>
                        </Accordion.Header>

                        <Accordion.Body>
                          <div className="products_brands_root">
                            <div className="sub_products">
                              <ul className="product_descrip_columns">
                                {item.product_descrip.map((product) => (
                                  <li
                                    className="product_names"
                                    onClick={() => {
                                      brandHandler(item.id);
                                      scrollView();
                                    }}
                                  >
                                    {product}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            {/* <div className="sub_products">
                              <p>Brand Listing : </p>
                              <ul className="product_descrip_columns">
                                {item.brand_listing.map((brand) => (
                                  <li>{brand}</li>
                                ))}
                              </ul>
                            </div> */}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="products_brand_wrapper" id="brands">
          <h3 className="mb-5 brand-title">Brands</h3>
          <Slider {...settings}>
            {brandData.brand_listing.map((item, key) => (
              <div key={key}>
                <div className="custom_card">
                  <div className="card_image">
                    <img
                      src={`/assets/images/products/${brandData.brand_images[key]}`}
                    ></img>
                    <hr className="image_line"></hr>
                  </div>
                  <Accordion>
                    <Accordion.Item eventKey={key}>
                      <Accordion.Header>
                        <p
                          className="product_name"
                          dangerouslySetInnerHTML={{
                            __html: item,
                          }}
                        ></p>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="products_brands_root">
                          <p>hey</p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};
export default Products;
